<template>
  <div>
    <vs-button color="black" :size="size" @click="createStpAccount" v-if="stpAccount == null" class="my-2">
      Crear cuenta STP
    </vs-button>
    <div v-else>
      <div
        class="border border-gray-300 rounded-lg p-2 flex items-center justify-between gap-2 cursor-pointer my-2 text-sm text-left"
        @click="copyStpClabe">
        <div class="w-10 h-10 flex items-center justify-center rounded-lg" style="background-color: #f0f0f0;">
          <i class="fas fa-copy"></i>
        </div>
        <div class="flex-1">
          <span class="font-bold">CLABE STP</span>
          <div>
            <stp-account-status-icon :status="stpAccount.status" />
            {{ stpAccount.stp_clabe }}
          </div>
          <span class="text-xs text-danger font-bold"
            v-if="stpAccount.status === 'error' || stpAccount.status === 'disabled'">
            {{ stpAccount.error_details }}
          </span>
        </div>
        <div class="w-10 h-10 flex items-center justify-center rounded-lg" v-if="stpAccount.status !== 'created'">
          <vx-tooltip title="Cuenta STP" :text="`Esta cuenta STP se encuentra en estado '${stpAccount.status}', usa
            este botón para crear una nueva.`" color="black" position="top">
            <vs-button text="Actualizar" icon="refresh" color="black" @click="createStpAccount"></vs-button>
          </vx-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StpAccountStatusIcon from "@views/admin/SupplierPayment/StpAccountStatusIcon";

export default {
  name: "StpButton",
  components: {
    StpAccountStatusIcon
  },
  props: {
    variant: {
      type: String,
      required: true,
      options: ['investor', 'supplier', 'applicant']
    },
    id: {
      type: [String, Number],
      required: true
    },
    size: {
      type: String,
      default: 'small',
      options: ['small', 'medium', 'large']
    }
  },
  data: () => ({
    stpAccount: null
  }),
  async mounted() {
    this.getStpAccount();
  },
  methods: {
    copyStpClabe() {
      navigator.clipboard.writeText(this.stpAccount.stp_clabe);
      this.successNotif('¡Listo!', 'La CLABE STP se copió correctamente');
    },
    async getStpAccount() {
      try {
        const { data } = await axios.get(`/api/stp/v1/account/${this.variant}Id/${this.id}`)
        this.stpAccount = data;
      } catch (e) {
        this.stpAccount = null;
      }
    },
    async createStpAccount() {
      this.$vs.loading();

      try {
        const { data } = await axios.post(`/api/stp/v1/account/${this.variant}Id/${this.id}`, {})
        this.stpAccount = data;
        this.successNotif('¡Listo!', 'La cuenta STP se creó correctamente');
        this.$emit('created', data);
      } catch (e) {
        this.$vs.loading.close();
        this.errorNotif('¡Ups!', 'Hubo un error al crear la cuenta STP');
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped></style>